export const FORM_ID = 'order-form';
export const FORM_EDIT_ID = 'edit-order-form';

// Nomi dei campi camelCase, utilizzare per confrontare il nome del campo corrente
export const PANEL_PRENOTAZIONE = [
  "nrPrenotazione", "nrSerata", "dataSerata"
];
export const PANEL_PRODOTTI = [
  "luceAttuale", "reteAttuale", "materassoAttuale", "numeroPiedini", "numeroFianchi", "noteAggiuntive", 
  "codArt_", "descArt_", "noteArt_", "dimArt_",
  "p1", "p2"
];
export const PANEL_PAGAMENTO = [
  "totale", "caparra", "modalitaIncassoCaparra", "caparraTrattenuta", "importoPrimaRata", "nrRate", "mesePosticipato",
  "accontoPosticipato", "accontoDimensione","importoSingolaRata", "NumeroAUT"      
];
export const PANEL_INDIRIZZO = [
  "via", "cap", "provincia", "localita", "via2", "cap2", "provincia2", "localita2"
];    
export const PANEL_CLIENTE = [
  "nome", "cognome", "cf", "iva", "telefono", "cellulare", "email", "noteContatti"
];
export const PANEL_NUOVO_CLIENTE = [
  "FlagClienteNuovo", "ProvenienzaCliente"
];

// Oggetto utilizzato per stampare il riepilogo come pdf
export const fields = {  
  // Prenotazione
  nrPrenotazione: "Nr. Prenotazione", 
  nrSerata: "Nr. serata",
  dataSerata: "Data serata",
  // Prodotti
  luceAttuale: "Luce attuale",
  reteAttuale: "Rete attuale", 
  materassoAttuale: "Materasso attuale", 
  codArt_: "Codice articolo", 
  descArt_: "Descrizione", 
  noteArt_: "Note aggiuntive",
  // Pagamento
  totale: "Totale", 
  caparra: "Caparra", 
  modalitaIncassoCaparra: "Modalità caparra",
  numeroAutorizzazione: "Numero autorizzazione",
  caparraTrattenuta: "Caparra trattenuta",
  importoPrimaRata: "Rata alla consegna", 
  nrRate: "Nr. rate", 
  mesePosticipato: "Nr. mesi posticipo",
  accontoPosticipato: "Acconto posticipato", 
  accontoDimensione: "Acconto dimensione",
  importoSingolaRata: "Importo singola rata",
  // Cliente  
  nome: "Nome", 
  cognome: "cognome", 
  cf: "Codice fiscale", 
  iva: "Partita Iva", 
  telefono: "Telefono", 
  cellulare: "Cellulare", 
  email: "Email", 
  noteContatti: "Note di contatto",
  via: "Via", 
  cap: "Cap", 
  provincia: "Provincia", 
  localita: "Località"  
}


// WEBPACK FOOTER //
// ./src/cmp/Orders/formFields.js